import {authConstants} from '../index';

import hasRole from './hasRole';


/**
 * @returns {boolean} True if the current user is a viewing user only
 */
function isViewingUser() {

    return !hasRole(authConstants.ROLE_FEATURE_CART);
}


export default isViewingUser;
